<template>
  <div
    class="d-flex text-center m-auto"
    style="width:fit-content"
  >
    <div class="d-flex flex-column justify-content-center">
      <feather-icon
        icon="ArrowRightCircleIcon"
        size="30"
        class="m-1 cursor-pointer"
        :class="{'text-primary':arrowRightHover , 'cursor-pointer' : arrowRightHover} "
        color="primary"
        @mouseenter="arrowRightHover=true"
        @mouseleave="arrowRightHover=false"
        @click="decreaseDate()"
      />
    </div>
    <div class="d-flex flex-column justify-content-center">
      <date-picker
        v-model="dietInDate"
        style="width:150px"
        class="d-inline-block"
      />
    </div>
    <div class="d-flex flex-column justify-content-center">
      <feather-icon
        icon="ArrowLeftCircleIcon"
        size="30"
        class="m-1"
        :class="{'text-primary':arrowLeftHover , 'cursor-pointer' : arrowLeftHover } "
        color="primary"
        @mouseenter="arrowLeftHover=true"
        @mouseleave="arrowLeftHover=false"
        @click="increaseDate()"
      />
    </div>
  </div>
</template>
<script>

export default {
  name: 'DataPickerStep',
  props: {
    value: { type: String, default: '' },
  },
  data() {
    return {
      dietInDate: null,
      arrowLeftHover: false,
      arrowRightHover: false,
    }
  },
  watch: {
    dietInDate(val) {
      this.$emit('input', val)
    },
    value(val) {
      this.dietInDate = val
    },
  },
  created() {
    this.dietInDate = this.$moment().format('YYYY-MM-DD')
  },
  methods: {
    increaseDate() {
      this.dietInDate = this.$moment(this.dietInDate).add(1, 'days').format('YYYY-MM-DD')
    },
    decreaseDate() {
      this.dietInDate = this.$moment(this.dietInDate).subtract(1, 'days').format('YYYY-MM-DD')
    },
  },
}
</script>

<style scoped>

</style>
